
// 1-强制 2-非强制
export enum TRANSFER_TYPE_MAP {
  FORCE = 1,
  UNFORCE = 2
}

// 1-每次 2-每日 3-终身
export enum POPUP_TYPE_MAP {
  EACHTIME = 1,
  EVERYDAY = 2,
  FORLIFE = 3
}

// 场景
export enum POPUP_SCENE {
  ENTRY = 1,
  DEPOSIT = 2
}